/** Cloud storage a firm connects so client files also land in its own drive.
 * Google Drive is the only provider today; a new one is a new API adapter. */
export const storageProviders = ["google_drive"] as const

export type StorageProvider = (typeof storageProviders)[number]

export const storageConnectionStatuses = [
  "active",
  "error",
  "disconnected",
] as const

export type StorageConnectionStatus = (typeof storageConnectionStatuses)[number]

/** Why a connection stopped copying. Each one names who acts next: the firm
 * reconnects, makes a new folder, or frees space. */
export const storageConnectionErrorCodes = [
  "reconnect",
  "root_missing",
  "quota_full",
] as const

export type StorageConnectionErrorCode =
  (typeof storageConnectionErrorCodes)[number]

export const storageSyncStatuses = [
  "pending",
  "uploaded",
  "failed",
  "skipped",
  "canceled",
] as const

export type StorageSyncStatus = (typeof storageSyncStatuses)[number]

/** What a copy was made from. Signed documents ship in the enum now; their
 * discovery arrives with the e-sign tables. */
export const storageSourceKinds = ["portal_upload", "signed_document"] as const

export type StorageSourceKind = (typeof storageSourceKinds)[number]

/** Why one file did not copy, recorded on the row for the failures list. */
export const storageSyncErrorCodes = [
  "provider_unavailable",
  "file_rejected",
  "source_unreadable",
] as const

export type StorageSyncErrorCode = (typeof storageSyncErrorCodes)[number]
